import { ClientNode } from '../../../model/client-model/client-node';
import { ModelType } from '../../../model/client-model/properties/model-type';
import { NodeType } from '../../../model/client-model/properties/node-type';
import { envelopeTEMatchesInstantiatedTE } from './envelope-te-matches-instantiated-te';
import { hasSelectedTE } from './has-selected-te';

/**
 * Returns true if the node has an initiated transition element.
 *
 * Note: This will return true even if the TE is unsupported by climate cortex.
 * @param node
 */
export function holdsInitialisedUtilisationTE(node: ClientNode): boolean {
  return (
    hasSelectedTE(node) &&
    node.nodeProperties?.type === NodeType.Target &&
    !(node.nodeProperties.modelType === ModelType.CUSTOM) &&
    envelopeTEMatchesInstantiatedTE(node.nodeProperties)
  );
}
